import { useState } from "react";
import { Link } from "react-router-dom";
import * as API from "../services/API";
import HeaderHome from "../headers/headerHome";
import Footer from "../components/Footer";
import "../css/ResetPassword.css";

export default function ForgotPassword() {
  const [identifier, setIdentifier] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = (event) => {
    event.preventDefault();
    setError("");
    setSuccess("");

    if (!identifier.trim()) {
      setError("Veuillez saisir votre adresse e-mail ou votre identifiant.");
      return;
    }

    setLoading(true);
    API.forgotPasswordRequest(
      identifier.trim(),
      (response) => {
        setSuccess(response.data.message);
        setLoading(false);
      },
      (message) => {
        setError(message);
        setLoading(false);
      }
    );
  };

  return (
    <>
      <HeaderHome />
      <div className="reset-container">
        <div className="reset-card">
          <h2>Mot de passe oublié</h2>
          <p className="reset-description">
            Saisissez votre adresse e-mail ou votre identifiant. Si un compte
            correspond, vous recevrez un lien valable 30 minutes.
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="reset-identifier">E-mail ou identifiant</label>
              <input
                id="reset-identifier"
                type="text"
                value={identifier}
                onChange={(event) => setIdentifier(event.target.value)}
                disabled={loading || Boolean(success)}
                autoComplete="username"
                autoFocus
              />
            </div>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            {!success && (
              <button type="submit" disabled={loading} className="reset-button">
                {loading ? "Envoi en cours..." : "Envoyer le lien"}
              </button>
            )}
          </form>

          <Link className="reset-back-link" to="/login">
            Retour à la connexion
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}
